import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import { fetchUserData, leaveViewDashboardMode } from '../../../store/authorization';
import { Button, Logo, PopOver } from '../../';
import { resetDraft, saveUnSavedDraftAndLogOut } from '../../../store/drafts';
import { useCurrentRole } from '../../../hooks/useCurrentRole';
import { URLS } from '../../../constants/constants';
import { LodashHelper } from '../../../utils';
import { useTheme } from '../../../contexts/ThemeContext';


import styles from './index.module.css';
import { Navigation } from '../../../utils/navigation';
import QuickScheduleModal from '../../modals/QuickScheduleModal/QuickScheduleModal';

const renderHeadersElements = ({
  isMHAdmin,
  isHOWorker,
  isEnterpriseAdmin,
  location,
  navigateToCreateRide,

}) => {
  if (isMHAdmin) {
    return <p className={styles.userRole}>Administrator</p>;
  } 

  else{
     
    return (
      isHOWorker && !isEnterpriseAdmin && (
        <div
          className={classnames({
            [styles.requestRide]: isHOWorker,
            [styles.requestRide]: true,
          })}>
          <Button
            myClassName={classnames({
              [styles.requestRideBtn]: isHOWorker,
              [styles.active]: location?.pathname === URLS.CREATE_RIDE,
            })}
            disabled={location?.pathname === URLS.CREATE_RIDE}>
            <NavLink to={URLS.CREATE_RIDE} onClick={navigateToCreateRide}>
              Request a Ride
            </NavLink>
          </Button>


        </div>
      )
    );
  }
};

export const Header = ({ user, role, setVisibleQuickSchedule }) => {
  const navigate = Navigation();
  const [visible, setVisible] = useState(false);
  const { isMHAdmin, isHOWorker, isDriver, isEnterpriseAdmin } = useCurrentRole(role);
  const viewDashboardMode = useSelector((state) => state.authorization.viewDashboardMode);
  const dispatch = useDispatch();
  const { activeTheme, setActiveTheme, themes } = useTheme();

  // Check if we should show the theme selector (only on enterprise.medhaul.link)
  const showThemeSelector = window.location.hostname.toLowerCase().includes('enterprise.medhaul.link') || 
                            window.location.hostname.toLowerCase() === 'localhost' ||
                            window.location.hostname.toLowerCase() === '127.0.0.1';

  const themeOptions = Object.keys(themes).map(key => ({
    label: key.charAt(0).toUpperCase() + key.slice(1),
    value: key,
  }));

  const handleThemeChange = (value) => {
    setActiveTheme(value);
  };


  const handleLogout = useCallback(() => dispatch(saveUnSavedDraftAndLogOut(navigate)), [dispatch]);

  const handleLeaveViewDashboardMode = useCallback(() => { dispatch(leaveViewDashboardMode(navigate)) }, [dispatch]);

  const handleRedirection = useCallback(() => navigate.push(URLS.RIDES), [navigate]);

  useEffect(() => {
    if (role !== 'RIDER') {
      {
        (LodashHelper.isEmpty(user) || !role) && dispatch(fetchUserData(navigate))
      }
      return;
    }
  }, [user, role]);

  const toggleVisibility = useCallback(() => setVisible(!visible), [visible]);

  const navigateToCreateRide = useCallback((e) => {

    dispatch(resetDraft());

    if (viewDashboardMode?.active) {

      setVisibleQuickSchedule(true);
    } else {


      dispatch(resetDraft());
      navigate.push(URLS.CREATE_RIDE, { from: navigate?.location.pathname });
    }
    e?.preventDefault(); // Optional chaining in case `e` is undefined
  }, [dispatch, viewDashboardMode?.active, navigate, setVisibleQuickSchedule]);






  return (
    <header
      className={classnames({
        [styles.header]: true,
        [styles.driverHeader]: isDriver,
      })}>
      <Logo
        md
        className={classNames({
          [styles.logoView]: viewDashboardMode?.active,
        })}
        onClick={handleRedirection}
      />
      {viewDashboardMode?.active && <h2 className={styles.viewDashboardTitle}>{viewDashboardMode.organizationName}</h2>}
      {renderHeadersElements({
        isMHAdmin,
        isHOWorker,
        isEnterpriseAdmin,
        location: navigate?.location,
        navigateToCreateRide,

      })}

      {/* Theme Selector - Only visible on enterprise.medhaul.link */}
      {/* {showThemeSelector && (
        <div className={styles.themeSelector}>
          <Select
            value={activeTheme}
            onChange={handleThemeChange}
            options={themeOptions}
            className={styles.themeDropdown}
            popupClassName={styles.themeDropdownPopup}
            placeholder="Select Theme"
            style={{ minWidth: 120 }}
          />
        </div>
      )} */}

      {/* Render the modal */}


      {role !== 'RIDER' &&
        <PopOver
          role={role}
          user={user}
          visible={visible}
          viewDashboardMode={viewDashboardMode?.active}
          handleLeaveViewDashboardMode={handleLeaveViewDashboardMode}
          handleLogout={handleLogout}
          toggleVisibility={toggleVisibility}
        />
      }
    </header>
  );
};

Header.propTypes = {
  user: PropTypes.object,
  role: PropTypes.string,
};